<ng-container>
    <div class="overlay-warp">
        <div class="itemx" *ngFor="let item of statusList">
            <div [ngSwitch]="item.status">
                <div class="item-list">
                    <div class="choose"  [ngClass]="{'selected': item.choosed}" (click)="selectStatus(item)">
                        <div class="inner-selected">
                            <img src="/assets/images/auto-fill/vi.svg">
                        </div>
                    </div>
                    <div *ngSwitchCase="enumQStatus.PendingApproval" class="st pending-approval">
                        <img src="/assets/images/grid/status/edit.svg">
                        <p translate>grid.status.pendingApproval</p>
                    </div>
                    <div *ngSwitchCase="enumQStatus.PendingPrevApproval" class="st pending-approval">
                        <img src="/assets/images/grid/status/edit.svg">
                        <p translate>grid.status.pendingPrevApproval</p>
                    </div>
                    <div *ngSwitchCase="enumQStatus.Approved" class="st approvaled">
                        <img src="/assets/images/grid/status/answered.svg">
                        <p translate>grid.status.approved</p>
                    </div>
                    <div *ngSwitchCase="enumQStatus.Rejected" class="st rejected">
                        <img src="/assets/images/x.svg">
                        <p translate> grid.status.rejected</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>